export default "__VITE_ASSET__DAg95rxU__"